import { useState } from "react";
import { motion } from "framer-motion";
import { Menu, X, Sparkle } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const links = [
    { label: "The Story", id: "chapters" },
    { label: "Support", id: "support" },
    { label: "FAQ", id: "faq" },
];

export default function Nav() {
    const [open, setOpen] = useState(false);
    const go = (id) => {
        setOpen(false);
        scrollToId(id);
    };
    return (
        <motion.header
            initial={{ y: -80, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1], delay: 0.2 }}
            className="fixed inset-x-0 top-0 z-50 border-b border-warmgray/70 bg-cream/70 backdrop-blur-xl"
        >
            <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10">
                <button
                    data-testid="nav-logo"
                    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                    aria-label="Ago GenApp home"
                >
                    <img src="/logo.png" alt="Ago GenApp" className="h-9 w-auto" />
                </button>
                <nav className="hidden items-center gap-8 md:flex">
                    {links.map((l) => (
                        <button
                            key={l.id}
                            data-testid={`nav-link-${l.id}`}
                            onClick={() => go(l.id)}
                            className="text-sm font-medium text-navy transition-colors duration-300 hover:text-navy/70"
                        >
                            {l.label}
                        </button>
                    ))}
                    <button
                        data-testid="nav-signin-button"
                        onClick={() => (window.location.href = "/auth")}
                        className="text-sm font-medium text-navy transition-colors duration-300 hover:text-navy/70"
                    >
                        Sign in
                    </button>
                    <button
                        data-testid="nav-support-cta"
                        onClick={() => go("support")}
                        className="btn-gradient rounded-full px-5 py-2.5 text-sm font-medium text-white shadow-lg shadow-navy/10 transition-transform duration-300 hover:-translate-y-0.5"
                    >
                        Become a Founding Supporter
                    </button>
                </nav>
                <button
                    data-testid="mobile-menu-button"
                    aria-label="Toggle menu"
                    onClick={() => setOpen(!open)}
                    className="text-navy md:hidden"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>
            {open && (
                <div className="border-t border-warmgray/70 bg-cream/95 px-6 py-4 backdrop-blur-xl md:hidden">
                    {links.map((l) => (
                        <button
                            key={l.id}
                            data-testid={`mobile-nav-link-${l.id}`}
                            onClick={() => go(l.id)}
                            className="block w-full py-3 text-left text-sm text-indigo"
                        >
                            {l.label}
                        </button>
                    ))}
                    <button
                        data-testid="mobile-nav-signin"
                        onClick={() => { setOpen(false); window.location.href = "/auth"; }}
                        className="block w-full py-3 text-left text-sm font-medium text-navy"
                    >
                        Sign in
                    </button>
                    <button
                        data-testid="mobile-nav-support-cta"
                        onClick={() => go("support")}
                        className="btn-gradient mt-2 w-full rounded-full px-5 py-3 text-sm font-medium text-white"
                    >
                        Become a Founding Supporter
                    </button>
                </div>
            )}
        </motion.header>
    );
}
